import { customAgentPermissions, qaAgentPermissions } from "./constants";
import type { AgentAction, AgentPermission, InteractionSite } from "./types";
import { isQaInteractionSite } from "./types";

/**
 * The permissions authorizing an action on agents of an interaction site:
 * holding any one of them is enough. Mirrors
 * CustomerAgentDefinition.permissions_for. Standards (the QA sites) have
 * permissions of their own, but the Canvas and Data Agents permissions still
 * authorize them until every existing holder has been granted the new ones.
 * TODO(AIML-5680): drop that fallback once GrantQaAgentPermissions has run on
 * every cluster.
 */
export const agentPermissionsGetter = (
  action: AgentAction,
  interactionSite: InteractionSite | undefined
): AgentPermission[] => {
  if (isQaInteractionSite(interactionSite)) {
    return [qaAgentPermissions[action], customAgentPermissions[action]];
  }
  return [customAgentPermissions[action]];
};
